import { getPagesBySlugList } from "@/lib/page/page-lookup"
import { PageType } from "@/lib/page/types"
import Link from "next/link"

interface RelatedPagesSectionProps {
  relatedPages: string[] | undefined
  currentPageType: PageType
  className?: string
}

export async function RelatedPagesSection({
  relatedPages,
  currentPageType,
  className = "",
}: RelatedPagesSectionProps) {
  if (!relatedPages || relatedPages.length === 0) {
    return null
  }

  // Use the unified lookup system to find all related pages
  const relatedPagesData = await getPagesBySlugList(
    relatedPages,
    currentPageType
  )

  return (
    <div className={`${className}`}>
      <div className="flex flex-wrap gap-2">
        {relatedPagesData.map(page => {
          return (
            <Link
              key={page.slug}
              href={page.slug}
              className="inline-block rounded-full bg-blue-100/70 px-4 py-2 text-sm text-blue-800 transition-all hover:bg-blue-200/70 dark:bg-blue-900/30 dark:text-blue-300 dark:hover:bg-blue-800/40"
            >
              {page.title}
            </Link>
          )
        })}
      </div>
    </div>
  )
}
